import m from "../../geodata/es2015/dominicanRepublicLow";
window.am4geodata_dominicanRepublicLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/dominicanRepublicLow.js
// module id = null
// module chunks = 